/* eslint-disable @typescript-eslint/explicit-function-return-type */
import axios from "axios";
import { DOMAIN_LIVE} from "./Config";
import { Toast } from "antd-mobile";
const CancelToken = axios.CancelToken;
const request = async (uri, { method = "POST", data, header = {} }) => {
  const search=new URLSearchParams(window.location.search);
  let DOMAINLAST=DOMAIN_LIVE;
  
  let headers={
    "Content-Type": "application/json",
    ...header,
  };
  if(window.cancleList[uri]){
    window.cancleList[`${uri}`]();
    await new Promise((resolve, reject) => {
      setTimeout(() =>{
        resolve(1)
      },5)
    })
  }
  const moredata = new URL(window.location.href).searchParams.toString();
  uri += uri.indexOf("?") > 0 ? `&${moredata}` : `?${moredata}`;
  const requestOptions = {
    url: DOMAINLAST + uri,
    method,
    headers: headers,
    withCredentials: true,
    cancelToken: new CancelToken(c => {
      // 调用c就可以取消此请求
      window.cancleList[uri]=c;
    }),
    validateStatus: (status) => status >= 200 && status <= 401,
  };
  if (method === "POST") {
    requestOptions.data = JSON.stringify(data);
  }
  return axios(requestOptions)
    .then(({ data}) => {
      delete window.cancleList[uri];
      if (data.result === "success") {
        return { data };
      } 
        if (data.result === "redirect") {
          window.location.href = data.data;
          return;
        }
        if (data.result === "autherror") {
          return;
        }
        Toast.show(data.message || "请求失败，请重试!");
        return { err: data.message };
      
    })
    .catch((err) =>{
      delete window.cancleList[uri];
      return { err }
    });
};

export default request;